<div
  class="dropdown"
  (openChange)="handleDropdownOpenChange($event)"
  ngbDropdown
>
  <button
    type="button"
    class="btn d-flex justify-content-between align-items-center dropdown-toggle form-control"
    ngbDropdownToggle
    [disabled]="disabled"
  >
    @if (selectedChildren()?.length) {
      <div class="truncate-text">
        @switch (selectedChildren()?.length) {
          @case (1) {
            <ng-template
              [ngTemplateOutlet]="templateRef()"
              [ngTemplateOutletContext]="{
                $implicit: selectedChildren()[0] || {}
              }"
            ></ng-template>
          }
          @default {
            {{ selectedChildren().length }} {{ multipleItemsSelectedText() }}
          }
        }
      </div>
    } @else {
      {{ placeholderText() | translate }}
    }

    <div class="d-flex align-items-center">
      @if (selectedChildren()?.length) {
        <i class="icon icon--close ms-2" (click)="clear($event)"></i>
      }
      <i
        [class]="isDropdownOpened ? 'chevron-rotated' : 'chevron-non-rotated'"
        class="icon icon--chevron-down ms-2"
      ></i>
    </div>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-custom">
    <div
      class="animation-container"
      [class]="animationState === 'showParents' ? 'show-parent' : 'show-child'"
    >
      <div class="view-container parents">
        <p class="back-button semibold">{{ dropdownTitle() }}</p>
        @for (parent of items(); track parent.name) {
          <div (click)="selectParent(parent)">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0">{{ parent.name | translate }}</p>
              <i class="icon icon--chevron-right"></i>
            </div>
          </div>
        }
      </div>
      <div class="view-container children">
        <button
          im-icon-button
          (click)="backToParents()"
          [aria-label]="'general.previous_a' | translate"
        >
          <i iconStart class="icon icon--arrow-left" aria-hidden="true"></i>
        </button>
        @if (selectedParent()) {
          @for (child of selectedParent().items; track child.name) {
            <div
              class="d-flex justify-content-between"
              (click)="$event.stopPropagation()"
            >
              <label
                class="m-0 truncate-text"
                [for]="idPrefix + '-' + $index"
                >{{ child.name | translate }}</label
              >
              <input
                [id]="idPrefix + '-' + $index"
                type="checkbox"
                class="im:checkbox-input ms-3 flex-shrink-0"
                [checked]="
                  child.value
                    | appIsValueSelectedInDropdownStepper: selectedChildren()
                "
                (change)="selectChild(child)"
              />
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
